import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

interface Props {
    color?: string;
    width?: string;
    height?: string;
    viewBox?: string;
}

export const ExpandIcon = ({
    color = 'currentColor',
    width = '20px',
    height = '20px',
    viewBox = '0 0 16 16',
    ...rest
}: Props) => (
    <Svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <Path
            d="M6 2H3C2.44772 2 2 2.44772 2 3V6M14 6V3C14 2.44772 13.5523 2 13 2H10M10 14H13C13.5523 14 14 13.5523 14 13V10M2 10V13C2 13.5523 2.44772 14 3 14H6"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
